import { orderBy, uniqBy } from "lodash";
import moment from "moment";
import { routes } from "..";
import { matchPath } from "react-router-dom";

export function secondsToHoursAndMinutes(s: number): string {
  if (s === null) return "0";
  s = Number(s);
  var h = Math.floor(s / 3600);
  var m = Math.floor((s % 3600) / 60);
  s = Math.floor((s % 3600) % 60);
  var hDisplay = h > 0 ? h + (h === 1 ? "h " : "h ") : "";
  var mDisplay = m > 0 ? m + (m === 1 ? "m " : "m ") : "";
  var sDisplay = s > 0 ? s + (s === 1 ? "s" : "s") : "";
  if (hDisplay !== "" || mDisplay !== "") {
    return hDisplay + mDisplay;
  } else {
    return sDisplay;
  }
}

export const enumerateDaysBetweenDates = function (
  startDate: any,
  endDate: any
) {
  var dates = [];
  var currDate = moment(startDate).subtract(1, "day").startOf("day");
  var lastDate = moment(endDate).add(1, "day").startOf("day");
  while (currDate.add(1, "days").diff(lastDate) < 0)
    dates.push({ x: currDate.valueOf(), y: 0 });
  return dates;
};

export const prepareChartData = (data: any, dates: any) => {
  data = data?.map((d: any) => {
    return {
      x: moment(d.x).startOf("day").valueOf(),
      y: d.y,
    };
  });
  let merged = [...data, ...dates];
  merged = uniqBy(merged, "x");
  let final = orderBy(merged, ["x"], ["asc"]);
  return final;
};

export function calculateProgress(finishedUnits: number, totalUnits: number) {
  if (finishedUnits && totalUnits) return (finishedUnits / totalUnits) * 100;
  return 0;
}

export function getRemainingDays(endDate: any) {
  const today = moment().startOf("day");
  const end = moment(endDate).startOf("day");
  const diff = end.diff(today, "days");
  return Math.max(diff, 0); // Ensure no negative numbers
}

export function matchToPaths(pathToMatch: string) {
  let paths = routes[0].children?.map((route: any) => route.path);
  paths?.push(routes[1].path);

  for (const path of paths!) {
    let matched = matchPath(path, pathToMatch);
    if (matched !== null) {
      return matched;
    }
  }

  return null;
}

export function calculateTimeProgress(startDate: string, endDate: string) {
  const now = moment();
  const start = moment(Number(startDate));
  const end = moment(Number(endDate));

  if (now.isSameOrBefore(start)) return 0;
  if (now.isSameOrAfter(end)) return 100;

  const totalDuration = end.diff(start);
  const elapsed = now.diff(start);

  const progress = (elapsed / totalDuration) * 100;
  if (Number.isNaN(progress)) return 0;

  return progress.toFixed() || 0;
}

export function timeProgress(startDate: string, endDate: string) {
  const start = moment(parseInt(startDate));
  const end = moment(parseInt(endDate));
  const remaningDays = getRemainingDays(end);
  const hasStarted = start.isBefore(moment());
  const hasEnded = remaningDays === 0;

  if (hasEnded)
    return {
      status: "ENDED",
      label: "Assignment has ended",
    };
  if (!hasStarted)
    return {
      status: "NOT_STARTED",
      label: `Starts in ${getRemainingDays(start)} days`,
    };

  return {
    status: "IN_PROGRESS",
    label: `Ends in ${getRemainingDays(end)} days`,
  };
}
